import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'NiotaClassicDevicesDeviceDetailsVisualization',
  props: {
    allRelevantKeys: {
      type: Array,
      required: false,
      default: new Array()
    },
    isLoadingGraph: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    showLoadMorePackets: {
      type: Boolean,
      required: true
    },
    visualizeGraphsToggle: {
      type: Boolean,
      required: true
    },
    dynamicGraph: {
      type: Object,
      required: true
    },
    parsedPacketsSize: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: function data() {
    return {
      loadingGraph: true,
      limit: 10,
      graphKeys: [],
      graphData: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  watch: {
    isLoadingGraph: function isLoadingGraph() {
      this.initData();
    },
    allRelevantKeys: function allRelevantKeys() {
      this.initData();
    },
    dynamicGraph: function dynamicGraph() {
      this.initData();
    }
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.loadingGraph = this.isLoadingGraph;
      this.graphKeys = this.allRelevantKeys;
      this.graphData = this.dynamicGraph;
    },
    loadMorePackets: function loadMorePackets() {
      if (this.parsedPacketsSize === this.limit) {
        this.limit += 10;
      }

      this.$emit('loadParsedPackets', this.limit);
    },
    resetPackets: function resetPackets() {
      this.limit = 10;
      this.$emit('loadParsedPackets', this.limit);
    }
  }
};